import type { PageUISectionType, PageUITrailResultSection } from './pageUI';
import trailFromPageUISection from './trailFromPageUISection';

/**
 * A page a click can open. Add one once hosts can open it; each host switches on this.
 */
export type PageUIRecordPage = 'trail-detail';

/**
 * What clicking a section does. The host app decides how to carry it out (which page, same tab or new),
 * since that depends on where the response is shown.
 */
export type PageUIClickAction = {
  action: 'open-record-page';
  page: PageUIRecordPage;
  slug: string;
};

/**
 * Analytics for a corresponding click action
 */
export type PageUIEventProperties = {
  sectionType: PageUISectionType;
  sectionIndex: number;
  detailedSectionType: string;
  itemTypes: string[];
  itemSlug: string;
  itemId: number;
};

export type PageUIClick = {
  clickAction: PageUIClickAction;
  eventProperties: PageUIEventProperties;
};

/**
 * Builds a trail result's click on the client, until the server sends `clickAction` and `eventProperties`.
 */
const clickFromSection = (section: PageUITrailResultSection, sectionIndex: number): PageUIClick => {
  const { slug } = trailFromPageUISection(section);

  return {
    clickAction: { action: 'open-record-page', page: 'trail-detail', slug },
    eventProperties: {
      sectionType: section.sectionType,
      sectionIndex,
      detailedSectionType: section.sectionType,
      itemTypes: ['trail'],
      itemSlug: slug,
      itemId: section.trailId
    }
  };
};

export default clickFromSection;
